import SimpleBar from "simplebar";

const ua = navigator.userAgent;
// var isIPad = ua.indexOf("iPad") > -1,
export const isIPad = ua.indexOf("iPad") > -1 || (ua.match(/Mac OS/) && "ontouchstart" in window);
export const isIPhone = ua.indexOf("iPhone") > -1;
export const isAndroid = ua.indexOf("Android") > -1 && ua.indexOf("Mobile") > -1;
export const isAndroidTab = ua.indexOf("Android") > -1;

// デバッグ用ここから
// const detected = [];
// if (isIPhone) detected.push("iPhone");
// if (isIPad) detected.push("iPad");
// if (isAndroid) detected.push("Android Mobile");
// if (isAndroidTab && !isAndroid) detected.push("Android Tablet");
// console.log("デバイス判定:", detected.length ? detected.join(" & ") : "PC");
// デバッグ用ここまで

const $html = $("html");
const classLocked = "is-locked";

$(function () {
  deviceSwitchLandscape();
  remodalCustom();
  loader();
  headerMenu();
  toTop();
  popup();
  shareLink();
  smoothScroll();
  simplebarInit();
});


$(function () {
  function updateVhUnit() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }

  updateVhUnit();

  $(window).on("resize orientationchange", updateVhUnit);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", updateVhUnit);
  }
});

//==========
//タブバーの高さを取得
//==========
// $(window).on("load resize", function() {
//   const isLandscape = window.innerWidth > window.innerHeight;
//   const rightControls = $(".play-control--right");

//   if (isLandscape) {
//     // URLタブの高さを取得 (Safari, Chrome, Firefox で動作確認)
//     let tabbarHeight = 0;
//     if (window.visualViewport) {
//       tabbarHeight = window.visualViewport.height - document.documentElement.clientHeight;
//     } else if (window.outerHeight) {
//       tabbarHeight = window.outerHeight - window.innerHeight;
//     }

//     // セーフエリアを考慮した padding-bottom を設定
//     const safeAreaInsetBottom = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--safe-area-inset-bottom") || 0, 10);
//     const paddingBottom = tabbarHeight + safeAreaInsetBottom + 20; // 20px は追加のマージン

//     // ★ ここで左右paddingも初期化
//     rightControls.css({
//       "padding-bottom": `${paddingBottom}px`,
//       "padding-left": "10px",
//       "padding-right": "10px"
//     });

//   } else {
//     // 縦向きはリセット
//     rightControls.css({
//       "padding-bottom": "",
//       "padding-left": "",
//       "padding-right": ""
//     });
//   }
// });

//==========
//デバイス別の表示コンテンツの切り替え
//==========

const style = document.createElement("style");
if (isIPhone || isAndroid) {
  style.textContent = ".js-only-tb:not(.js-only-sp), .js-only-pc:not(.js-only-sp) { display: none; }";
} else if (isIPad || isAndroidTab) {
  style.textContent = ".js-only-sp:not(.js-only-tb), .js-only-pc:not(.js-only-tb) { display: none; }";
} else {
  style.textContent = ".js-only-tb:not(.js-only-pc), .js-only-sp:not(.js-only-pc) { display: none; }";
}
document.head.appendChild(style);

//==========
//デバイスにより横向き非対応メッセージ切り替え
//==========
function deviceSwitchLandscape() {
  const message = ".js-landscape";

  //SP
  if (isIPhone || isAndroid) {
    $(message).addClass("is-active");

    //TB・PC
  } else {
    $(message).removeClass("is-active");
  }
}

//==========
// remodal custom
//==========
function remodalCustom() {
  $(document).on("opened", ".remodal", function () {
    screenLock();
  });
  $(document).on("closed", ".remodal", function () {
    screenUnlock();
  });
}

//==========
// スクロールロック
//==========
export function screenLock() {
  const top = $(window).scrollTop();

  if (!$html.hasClass(classLocked)) {
    $html
      .addClass(classLocked)
      .css({
        top: top * -1,
      })
      .data("top", top);
  }
}

export function screenUnlock() {
  const top = $html.data("top") || 0;

  if ($html.hasClass(classLocked)) {
    $html.removeClass(classLocked).css({
      top: "",
    });
    $(window).scrollTop(top);
  }
}

//==========
// Swiper 高さ調整
//==========
// function updateSwiperHeight() {
//   const windowWidth = $(window).width();
//   const $heroSwiper = $(".js-hero-swiper");

//   if (windowWidth > 768) {
//     const $activeSlide = $(".swiper-slide-active");
//     if ($activeSlide.length) {
//       const slideHeight = $activeSlide.outerHeight();
//       $heroSwiper.css("height", slideHeight + 100 + "px");
//     }
//   } else {
//     $heroSwiper.css("height", ""); // モバイル時は高さをリセット
//   }
// }

function applySafeViewportHeight() {
  if (!CSS.supports("height: 100dvh")) {
    const setVh = () => {
      const vh = window.visualViewport
        ? window.visualViewport.height * 0.01
        : window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVh(); // 初回実行

    // タブ復帰にも対応
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        setTimeout(setVh, 300); 
      }
    });

    window.visualViewport?.addEventListener("resize", setVh);
    window.addEventListener("orientationchange", setVh);
    window.addEventListener("resize", setVh);
  }
}

window.addEventListener("load", () => {
  applySafeViewportHeight();
});

//==========
// 共通ローダー
//==========
function loader() {
  setTimeout(function () {
    $(window).scrollTop("0");
  }, 600);

  if ($(".js-loader").length) {
    //ローダーitem処理
    $(".js-loader-item").delay(600).fadeOut(600);

    //ローダー背景処理
    $(".js-loader")
      .delay(900)
      .animate(
        {
          height: "0",
        },
        900,
        "swing",
        function () {
          $("html").addClass("is-loaded");
          $(this).hide();
        }
      );
  } else {
    $("html").addClass("is-loaded");
  }
}

/*音バグ解消のために確認画面を挟む*/
$(window).on("load", function () {
  const loader = $(".js-play-loader");
  const close = $(".js-play-loader-close");
  const main = $(".play-main");

  // ローディング中は背景の操作をブロック
  loader.on("click", function(e) {
    e.stopPropagation();
  });

  close.on("click", function () {
    loader.fadeOut();
    main.fadeIn();
    // ローディング終了時に背景操作ブロックを解除
    loader.off("click");
  });

});

//==========
// 横向きのタブバーの高さを取得してボタンの位置を調
$(window).on("load resize", function() {
  if (window.innerWidth > window.innerHeight) { // 横向きの場合
    const tabbarHeight = $(".tabbar").outerHeight(); // タブバーの高さを取得
    $(".play-control--right").css("padding-bottom", tabbarHeight + 20 + "px"); // ボタンの位置を調整
  } else { // 縦向きの場合
    $(".play-control--right").css("padding-bottom", ""); // padding-bottomをリセット
  }
});

//==========
// ヘッダー
// タッチ OR クリックかイベントを判定して開閉
//==========
function headerMenu() {
  const HEADER = $(".js-header");
  const BG_OVERLAY = $(".js-header-overlay");
  const GNAV_TARGET = $(".js-nav-target");
  const GNAV_SCROLL = $(".js-header-inner");
  const CLASS_OPEN = "is-open";
  const openEvent = new CustomEvent("open", {});
  const closeEvent = new CustomEvent("close", {});

  const closeMenu = () => {
    GNAV_TARGET.removeClass(CLASS_OPEN);
    BG_OVERLAY.removeClass(CLASS_OPEN);
    HEADER.stop().removeClass(CLASS_OPEN);
    GNAV_SCROLL.scrollTop(0);
    HEADER.get(0).dispatchEvent(closeEvent); // game.js連携 (game.jsでjqueryを使わないためdispatchEventを使用)
    screenUnlock();
  };

  const toggleMenu = () => {
    if (GNAV_TARGET.hasClass(CLASS_OPEN)) {
      closeMenu();
    } else {
      GNAV_TARGET.addClass(CLASS_OPEN);
      HEADER.stop().addClass(CLASS_OPEN);
      BG_OVERLAY.addClass(CLASS_OPEN);
      HEADER.get(0).dispatchEvent(openEvent); // game.js連携 (game.jsでjqueryを使わないためdispatchEventを使用)
      screenLock();
    }
  };

  // isIPhone, isIPad, isAndroid, isAndroidTab はファイル上部で定義済み
  const isTouchDevice = isIPhone || isIPad || isAndroid || isAndroidTab;
  const eventType = isTouchDevice ? "touchend" : "click";

  GNAV_TARGET.on(eventType, toggleMenu);
  BG_OVERLAY.on(eventType, closeMenu);
}

//==========
//スムーズスクロール
//==========
function smoothScroll() {
  $.easing.quart = function (x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  };

  $(".js-scroll").click(function () {
    var speed = 1200,
      href = $(this).attr("href"),
      target = $(href == "#" || href == "" ? "html" : href),
      position = target.offset().top;

    $("html, body").animate(
      {
        scrollTop: position,
      },
      speed,
      "quart"
    );

    return false;
  });
}

//==========
// ページトップ スクロールボタン
//==========
function toTop() {
  const $toTopTrigger = $(".js-to-top"),
    windowHeight = $(window).height();

  $(window).scroll(function () {
    if ($(this).scrollTop() > windowHeight / 2) {
      $toTopTrigger.addClass("is-fadein");
    } else {
      $toTopTrigger.removeClass("is-fadein");
    }
  });

  $toTopTrigger.click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
}

//==========
// ポップアップ （メディアデバイスお知らせ）
//==========
function popup() {
  var popup = $(".js-popup");
  var popupClose = popup.find(".js-popup-close");

  // 初期状態でポップアップを非表示にする
  popup.removeClass("is-opened");

  // メディア機器の変更を検知
  if (navigator.mediaDevices && navigator.mediaDevices.addEventListener) {
    navigator.mediaDevices.addEventListener("devicechange", function () {
      // ポップアップを表示
      popup.addClass("is-opened");

      // 3秒後にポップアップを非表示
      setTimeout(function () {
        popup.removeClass("is-opened");
      }, 3000);
    });
  }

  popupClose.on("click", function () {
    popup.removeClass("is-opened");
  });
}

//==========
//SNSシェア
//==========
function shareLink() {
  const uaSP = isIPhone || isIPad || isAndroid || isAndroidTab; //lineアプリ対応
  const pageTitle = encodeURIComponent(document.title);
  const pageUrl = (source, encode = true) => {
    const url = window.location.origin + window.location.pathname;
    const urlWithUtm = `${url}?utm_source=${source}&utm_medium=social&utm_campaign=share`;
    return encode ? encodeURIComponent(urlWithUtm) : urlWithUtm;
  };

  /* ----------
    data属性あり：それを挿入
    data属性なし：現在のページURLとタイトルを挿入
  ---------- */

  //Twitterシェア
  $(".js-share-tw").click(function (e) {
    e.preventDefault();
    pushShareDataLayer("Twitter");
    const hashtag = $(this).data("hashtag");
    const url = "//x.com/intent/tweet" 
              + `?url=${pageUrl("X")}`
              + `&hashtags=${hashtag}`;
    window.open(url, "_blank");
  });

  //Facebookシェア
  $(".js-share-fb").click(function (e) {
    e.preventDefault();
    pushShareDataLayer("Facebook");
    const url = "//www.facebook.com/sharer/sharer.php"
              + `?u=${pageUrl("Facebook")}`
              + `&text=${pageTitle}`;
    window.open(url, "_blank");
  });

  //LINEシェア
  $(".js-share-line").click(function (e) {
    e.preventDefault();
    pushShareDataLayer("LINE");

    //スマホ・タブレットはLINE URLスキーム、PCはLINE Social Pluginsに切り替え
    const url = uaSP ? "//line.me/R/msg/text/"
                      + `?${pageTitle}` 
                      + ` ${pageUrl("LINE")}`
      : "//social-plugins.line.me/lineit/share"
                      + `?url=${pageUrl("LINE")}`
                      + `&text=${pageTitle}`;
                     
    window.open(url, "_blank");
  });

  //シェアURLコピー
  $(".js-share-copy").click(function (e) {
    e.preventDefault();
    pushShareDataLayer("URL");
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(pageUrl("URL", false))
        .then(() => {
          // フラッシュメッセージ表示
          $(".js-share-copy-message").fadeIn(200, function () {
            $(this).delay(1500).fadeOut(300);
          });
        })
        .catch(() => {
          alert("コピーに失敗しました");
        });
    } else {
      alert("このブラウザではコピー機能が使えません");
    }
  });
}

//シェア時のGTM処理
function pushShareDataLayer(method) {
  const data = {
    event: "share",
    share_method: method
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

//==========
// トップswiperの呼び出し
//==========
document.addEventListener("DOMContentLoaded", () => {
  if (window.initInfoSlider) {
    window.initInfoSlider();
  }
});

//==========
// タッチデバイスのみsimplebarを有効化
//==========
function simplebarInit() {
  const simplebarElements = document.querySelectorAll(".js-header-inner, .js-side-nav-panel, .js-mapInfo-body");
  if (typeof SimpleBar !== "undefined") {
    simplebarElements.forEach((el) => {
      new SimpleBar(el);
    });
  }
}
